import React from 'react';
import '../../styles-wa/DateSeparator.css';

/**
 * DateSeparator Component
 * Displays a date separator between message groups
 * Shows "Today", "Yesterday", or formatted date (e.g., "May 14, 2026")
 */
const DateSeparator = ({ dateLabel = '' }) => {
    return (
        <div className="date-separator-container">
            <div className="date-separator-line" />
            <div className="date-separator-label">
                {dateLabel}
            </div>
            <div className="date-separator-line" />
        </div>
    );
};

export default DateSeparator;



